const unsupportedNode = require('./helper').unsupportedNode;

module.exports = unsupportedNode('Complex gateways not supported by execution engine','bpmn:ComplexGateway');
